export interface PortfolioProject {
  id: string;
  title: { th: string; en: string };
  date: string;
  client: string;
  clientId: string; // Reference to client data
  category: string;
  description: { th: string; en: string };
  technologies: string[];
  images: string[];
  coverFit?: 'cover' | 'contain'; // how the card thumbnail fits (default 'cover')
  coverBg?: string;               // background behind a 'contain' cover (e.g. brand gradient)
  videoUrl?: string;
  liveUrl?: string | { th: string; en: string };
  github?: string;
  featured: boolean; // For highlighting main projects
  status: 'completed' | 'ongoing' | 'maintenance';
  projectType: 'ai' | 'blockchain' | 'integration' | 'mobile' | 'web';
  budget?: {
    range: string; // e.g., "100k-500k", "500k-1M"
    currency: 'THB' | 'USD';
  };
  duration?: {
    start: string; // YYYY-MM
    end?: string; // YYYY-MM, undefined if ongoing
  };
  teamSize?: number;
  achievements?: { th: string; en: string }[];
}

export const portfolioProjects: PortfolioProject[] = [
  {
    id: 'sansiri-ai-analytics',
    title: {
      th: 'น้องแสนรู้ - AI Assistant สำหรับ Sansiri',
      en: 'Sanroo - AI Assistant for Sansiri'
    },
    date: 'เมษายน 2019',
    client: 'Sansiri',
    clientId: 'sansiri',
    category: 'AI & Customer Experience',
    description: {
      th: 'พัฒนาพนักงานน้องใหม่ "น้องแสนรู้" ตัวจิ๋วสมองแจ๋วแห่ง The Cloud ที่สามารถแนะนำนวัตกรรมการอยู่อาศัยที่ช่วยยกระดับคุณภาพชีวิตลูกบ้านของแสนสิริ นำเสนอข้อมูลโครงการใหม่ได้ครบถ้วนแม่นยำเหนือมนุษย์ และสร้างประสบการณ์ที่น่าสนใจแม้กระทั่งการเต้นที่ทำให้ลูกค้ายิ้มออก ตอบโจทย์ลูกค้าที่ต้องการปฏิสัมพันธ์กับเทคโนโลยี',
      en: 'Developed the new smart employee "Sanroo" - a compact but brilliant AI at The Cloud. Capable of recommending residential innovations that elevate Sansiri residents\' quality of life, presenting comprehensive and accurate project information beyond human capability, and creating engaging experiences including entertaining dance moves that make customers smile. Perfect for customers who prefer technology interactions.'
    },
    technologies: ['Machine Learning', 'Computer Vision', 'Google Cloud', 'Python', 'Android'],
    images: [
      require('../assets/portfolio/sansiri/65592041_622424128271470_89000247883202560_n.jpg'),
      require('../assets/portfolio/sansiri/65583612_622423968271486_2408754557384392704_n.jpg'),
      require('../assets/portfolio/sansiri/65485644_622423914938158_7933685270166110208_n.jpg'),
      require('../assets/portfolio/sansiri/65596940_622428428271040_1532478995893846016_n.jpg'),
      require('../assets/portfolio/sansiri/65937529_622423934938156_9059122566081282048_n.jpg'),
      require('../assets/portfolio/sansiri/16300359.8beee682e83d6ac1de5868e885c13ab4.19070107.JPG')
    ],
    videoUrl: 'https://www.facebook.com/sansirifamily/videos/2964682913563122',
    liveUrl: {
      th: 'https://www.sansiri.com/thai',
      en: 'https://www.sansiri.com/en'
    },
    featured: true,
    status: 'completed',
    projectType: 'ai',
    duration: {
      start: '2019-02',
      end: '2019-04'
    },
    teamSize: 4,
    achievements: [
      {
        th: 'เพิ่มการมีส่วนร่วมของลูกค้าในงานแสดง 300%',
        en: 'Increased customer engagement at exhibitions by 300%'
      },
      {
        th: 'ลดเวลาตอบคำถามลูกค้าจาก 5 นาที เหลือ 30 วินาที',
        en: 'Reduced customer inquiry response time from 5 minutes to 30 seconds'
      }
    ]
  },
  {
    id: 'ocpb-pokpong',
    title: {
      th: 'พี่ปกป้อง — AI Assistant สำหรับ สคบ. (OCPB)',
      en: 'Pokpong — AI Assistant for OCPB'
    },
    date: '2025',
    client: 'OCPB (สคบ.)',
    clientId: 'ocpb',
    category: 'Government · rootBot (Silo)',
    description: {
      th: 'แชตบอท AI บนแพลตฟอร์ม rootBot (แบบ Silo) ให้สำนักงานคณะกรรมการคุ้มครองผู้บริโภค — ตอบคำถามผู้บริโภคด้วย RAG (สิทธิ ขั้นตอน คำถามพบบ่อย), รับแจ้งเบาะแส/ร้องเรียนเป็นฟอร์มหลายขั้นพร้อมแนบหลักฐานและรหัสติดตาม, ตรวจทะเบียนนิติบุคคล/อย./ขายตรง และส่งต่อเจ้าหน้าที่ผ่าน Live Chat ครบทุกช่องทาง',
      en: 'An AI chatbot on the rootBot platform (Silo deployment) for Thailand\'s Office of the Consumer Protection Board — answers consumer questions via RAG (rights, procedures, FAQs), handles multi-step complaint/tip-off forms with evidence upload and tracking codes, checks business/FDA/direct-sales registries, and hands off to officers via omnichannel live chat.'
    },
    technologies: ['rootBot', 'RAG', 'Google Gemini', 'PostgreSQL + pgvector', 'LINE OA', 'Facebook', 'Live Chat'],
    images: [
      require('../assets/rootbot/ocpb-mascot-pokpong.png'),
      require('../assets/rootbot/ocpb-logo.png')
    ],
    coverFit: 'contain',
    coverBg: 'linear-gradient(150deg,#0a1024,#13204a 55%,#1c2a5e)',
    featured: true,
    status: 'completed',
    projectType: 'ai'
  },
  {
    id: 'pdmo-payu',
    title: {
      th: 'พี่วายุ — AI Assistant สำหรับ สบน. (PDMO)',
      en: 'Payu — AI Assistant for PDMO'
    },
    date: '2025',
    client: 'PDMO (สบน.)',
    clientId: 'pdmo',
    category: 'Government · rootBot (Silo)',
    description: {
      th: 'แชตบอท AI บนแพลตฟอร์ม rootBot (แบบ Silo) ให้สำนักงานบริหารหนี้สาธารณะ — ถาม-ตอบเรื่องหนี้สาธารณะและนโยบายด้วย RAG จากเอกสาร/พ.ร.ก., ดึงสถิติหนี้แบบเรียลไทม์จาก API (หนี้รวม/สกุลเงิน/สัดส่วนต่อ GDP) และส่งต่อเจ้าหน้าที่ผ่าน Live Chat พร้อมระบบรีวิว',
      en: 'An AI chatbot on the rootBot platform (Silo deployment) for Thailand\'s Public Debt Management Office — answers public-debt and policy questions via RAG over official documents/decrees, pulls real-time debt statistics from APIs (total debt, currency mix, debt-to-GDP), and escalates to officers via live chat with review ratings.'
    },
    technologies: ['rootBot', 'RAG', 'Vertex AI (Gemini)', 'PDMO Debt API', 'PostgreSQL + pgvector', 'Live Chat'],
    images: [
      require('../assets/rootbot/pdmo-mascot-payu.png'),
      require('../assets/rootbot/pdmo-logo.png')
    ],
    coverFit: 'contain',
    coverBg: 'linear-gradient(150deg,#0a1024,#13204a 55%,#1c2a5e)',
    featured: true,
    status: 'completed',
    projectType: 'ai'
  },
  {
    id: 'bundhaya-trip-assistant',
    title: {
      th: 'Bundhaya Speedboat Trip Assistant',
      en: 'Bundhaya Speedboat Trip Assistant'
    },
    date: '2025',
    client: 'Bundhaya Speedboat',
    clientId: 'bundhaya',
    category: 'Travel · rootBot (Pool) · LIVE',
    description: {
      th: 'แชตบอทจองเรือ omnichannel บนแพลตฟอร์ม rootBot (แบบ Pool) ใช้งานจริงบน production — ตอบเส้นทาง/ตาราง/ราคา/ที่นั่งว่างแบบเรียลไทม์, เช็คโปรโมชั่นจริงผ่าน API (capability-gated เฉพาะบอท), รู้จักสมาชิกผ่าน signed-login เพื่อเสนอโปรเฉพาะสมาชิก และส่งลิงก์ไปหน้าจองจริงเพื่อปิดการขายในแชต',
      en: 'An omnichannel boat-booking chatbot on the rootBot platform (Pool deployment), live in production — answers routes/schedules/prices/seat availability in real time, checks live promotions through a capability-gated API, recognises members via signed-login for member-only offers, and sends booking links to close the sale inside the chat.'
    },
    technologies: ['rootBot', 'Web Widget', 'LINE OA', 'Facebook', 'signed-login', 'Omise (Card + PromptPay)', 'Firebase Auth'],
    images: [
      require('../assets/rootbot/bundhaya-logo.png')
    ],
    coverFit: 'contain',
    coverBg: 'linear-gradient(150deg,#0a1024,#13204a 55%,#1c2a5e)',
    liveUrl: 'https://v2.bundhayaspeedboat.com',
    featured: true,
    status: 'ongoing',
    projectType: 'ai'
  }
];